import {
  Button,
  Code,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import React from "react";
import { useDispatch } from "react-redux";
import { resetErrorLoadingStatus } from "../../Redux/App/app.actions";

const ErrorModal = ({ isOpen, onClose, title, text, imageSrc }) => {
  const dispatch = useDispatch();
  const handleStatus = () => {
    dispatch(resetErrorLoadingStatus());
  };
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay
        bg="blackAlpha.300"
        backdropFilter="blur(10px) hue-rotate(90deg)"
      />{" "}
      <ModalContent>
        <ModalHeader>{title}</ModalHeader>
        <ModalCloseButton onClick={handleStatus} />
        <ModalBody align="center" justify="center">
          {imageSrc && <Image h="100px" w="100px" src={imageSrc} />}
          {/* <Text mt="1rem">{text}</Text> */}
          <Code
            mt="1rem"
            fontSize="18px"
            p="10px"
            colorScheme="orange"
            children={text}
          />
        </ModalBody>
        <ModalFooter>
          {/* <Button onClick={onClose}>Close</Button> */}
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ErrorModal;
